var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1722.09 506.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#8c0001;}.cls-1{fill-rule:evenodd;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "627.25 0 627.25 67.56 478.99 67.56 478.99 506.69 405.8 506.69 405.8 76.6 414.85 67.56 482.4 0 627.25 0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 302.26,
    y1: 69.03,
    x2: 302.02,
    y2: 69.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 229.59,
    y1: 253.33,
    x2: 229.24,
    y2: 253.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,149.26A149.27,149.27,0,0,1,149.23,0H371L303.49,67.56,302,69H139.45l-.67.09a81,81,0,0,0-70.39,80.14c0,45,34.56,57.14,65.51,67.57l4,1.27,11.41,3.63-48.65,48.66c-9.25-2.75-28.37-10.86-35-15.38C26.14,228.15,0,200.61,0,149.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.21,368.1c0,76.41-62.18,138.59-138.59,138.59L0,505.81V437.58l184.36.7a69.94,69.94,0,0,0,69.83-66v-7.8c0-33.3-43.39-46.35-78.47-57.28l53.87-53.85L240,258l2.88,1.28c2.14,1,4.44,2,6.79,3,6.92,3.07,14.76,6.56,17.35,8C309.54,293.6,323.21,317.37,323.21,368.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M754.86,284.06V351H584.81v44.78A25.56,25.56,0,0,0,610,420.9H754.86v66.41H609c-49.81,0-90.56-40.75-90.56-90.56V238.28c0-49.81,40.75-90.56,90.56-90.56h145.9l-20.12,66.91H610a25.23,25.23,0,0,0-25.16,25.16v78l33.71-33.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1031.42,419.77v66.29H890.3c-49.72,0-90.4-40.68-90.4-90.4V237.46c0-49.72,40.68-90.4,90.4-90.4h141.12l-20.09,66.8h-120A25.18,25.18,0,0,0,866.19,239V394.65a25.52,25.52,0,0,0,25.11,25.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1359.08,
    y: 419.5,
    width: 66.56,
    height: 66.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1320.36,486.06H1253.8V350.44H1136.19V486.06h-66V148.26h66V317.41l33.54-33.53h84.07V148.26h66.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1652,486.06h-47.08V462.69l-23.37,23.37h-70.46a46.69,46.69,0,0,1-46.74-46.74V390c0-25.85,20.89-47.09,46.74-47.09h62.67L1587.57,390h-66.92a9.45,9.45,0,0,0-9.56,9.2v30.52a9.52,9.52,0,0,0,9.56,9.56h84.27V302.55a8.93,8.93,0,0,0-9.21-9.2H1483.12l14.16-47.09h107.64A46.84,46.84,0,0,1,1652,293.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1722.09,486.06V246.26h-46.74v239.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1722.09,193.8V147.06h-46.74V193.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c213ff589826d6657f89d3570623463.svg";
export { ForwardRef as ReactComponent };